module.exports = __webpack_public_path__ + "static/media/howLongQuestion.1b5017f4.mp3";